<mat-card>
    <mat-card-header>
        <mat-card-title>Marketing Alert</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-list role="list">
            <mat-list-item role="listitem">
                <mat-icon matListIcon>{{GLOBAL.ICONS.OFFLINE}}</mat-icon>
                <h3 matLine>{{action.portal | param:'portals'}} - <i>{{action.portalRef}}</i></h3>
            </mat-list-item>
            <mat-list-item role="listitem" *ngFor="let error of action.errors">
                <mat-icon matListIcon>{{GLOBAL.ICONS.ALERT}}</mat-icon>
                <h3 matLine>{{error}} </h3>
            </mat-list-item>
        </mat-list>
    </mat-card-content>
</mat-card>

<div class="actionButtons" *ngIf="!action.done">
    <button mat-icon-button class="active" [disabled]="item.saving" (click)="validAction()">
        <mat-icon>task_alt</mat-icon>
    </button>
</div>